<template>
	<div class="comparatorValueContainer">
		<div class="comparatorValue">
			<ComparedStatisticIconReverse :class="[
				value === comparated ? 'colorYellow' : (value > comparated ? 'colorGreen' : 'colorRed')
			]" :value="value" :comparated="comparated" />
		</div>
		<p :class="[
			value === comparated ? 'colorYellow' : (value > comparated ? 'colorGreen' : 'colorRed')
		]">{{ value - comparated }}<span v-if="props.percent">%</span></p>
	</div>
</template>

<script setup>
import ComparedStatisticIconReverse from '@/components/utilities/icons/comparedStatisticIconReverse.vue';

const props = defineProps({
	value: {
		type: Number,
		required: true,
	},
	comparated: {
		type: Number,
		required: true,
	},
	percent: {
		type: Boolean,
		default: true
	}
});
</script>

<style scoped lang="scss">
.comparatorValueContainer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;

	.comparatorValue {
		width: 1.7rem;
	}

	p {
		font-size: 0.8rem;
	}
}

.colorRed {
	color: var(--rouge-500);
	fill: var(--rouge-500);
}

.colorGreen {
	color: var(--vert-500);
	fill: var(--vert-500);
}

.colorYellow {
	color: var(--bleu-200);
	fill: var(--bleu-200);
}
</style>